import { create } from "zustand";

type NFCState = {
    reader_status: boolean;
    setReaderStatus: (reader_status: boolean) => void;
    card_status: boolean;
    setCardStatus: (card_status: boolean) => void;
    readData: string | null;
    setReadData: (readData: string | null) => void;
    ws: WebSocket | null,
    setWS: (ws: WebSocket | null) => void
}

export const useNFCStore = create<NFCState>((set) => ({
    reader_status: false,
    setReaderStatus: (reader_status) => set({ reader_status }),
    card_status: false,
    setCardStatus: (card_status) => set({ card_status }),
    readData: null,
    setReadData: (readData) => set({ readData }),
    ws: null,
    setWS: (ws) => set({ ws })
}))